// Finds the element with id="newsletter-widget" and replaces it with a React component
import React from "react";
import Newsletter from "../Newsletter/Newsletter.component";
import { NewsletterProps } from "./Newsletter.types";

export function replaceNewsletterWidget(props: NewsletterProps = {}) {
  if (typeof window === "undefined") return;
  const widget = document.getElementById("newsletter-widget");
  if (widget) {
    const mountPoint = document.createElement("div");
    widget.replaceWith(mountPoint);
    import("react-dom/client").then(({ createRoot }) => {
      createRoot(mountPoint).render(<Newsletter className="mt-6" {...props} />);
    });
  }
}
